module.exports = __webpack_public_path__ + "img/bg_1920.3982cac3.png";